<template>
    <form @submit="submitNewPassword">
      <Heading class="mb-16" center>Change Password</Heading>
      <div class="sm:flex mb-12">
        <div class="sm:mr-2 flex-1">
          <label for="password" class="text-sm">New password<small>*</small></label>
          <input type="password" class="input mt-2" id="password" v-model="currentPassword" />
        </div>
        <div class="sm:ml-2 flex-1 mt-4 sm:mt-0">
          <label for="password2" class="text-sm">Repeat password<small>*</small></label>
          <input type="password" class="input mt-2" id="password2" v-model="newPassword" />
        </div>
      </div>

      <div class="flex justify-between">
        <LoadingButton
          type="submit"
          class="btn-primary px-8 sm:px-12 w-full sm:w-auto"
          :disabled="!canSubmit"
          :loading="loading"
        >
          Change my password
        </LoadingButton>

        <button
          type="button"
          class="btn btn-secondary w-full sm:w-auto rounded-lg font-semibold px-8 sm:px-12"
          @click="$emit('close')"
        >
          <span>Cancel</span>
        </button>
      </div>

    </form>
</template>

<script>
  import DefaultCard from "../layout/DefaultCard"
  import Heading from "../Heading"
  import Api from '../../../api'
  import LoadingButton from "../LoadingButton"
  import { mapActions } from "vuex"

  export default {
    name: "ChangePassword",
    components: { LoadingButton, Heading, DefaultCard },
    data() {
      return {
        currentPassword: '',
        newPassword: '',
        loading: false,
      }
    },
    computed: {
      canSubmit() {
        return this.currentPassword && this.newPassword
      }
    },
    methods: {
      ...mapActions([
        'setSuccessMessage',
        'setErrorMessage'
      ]),
      async submitNewPassword(event) {
        event.preventDefault()
        try {
          if (this.newPassword.length < 8 || this.currentPassword.length < 8) {
            this.setErrorMessage('The password should be at least 8 characters')
          } else {
            this.loading = true
            await Api.changePassword({ password: this.currentPassword, password_confirmation: this.newPassword })
            this.setSuccessMessage('Password changed successfully!')
            this.loading = false
            this.currentPassword = ''
            this.newPassword = ''
          }
        } catch (e) {
          this.loading = false
          this.setErrorMessage('Could not update. Please make sure the passwords match')
        }
      }
    }
  }
</script>
